import React from 'react';
import { PrimaryButton, PrimaryButtonProps } from './PrimaryButton';
import SaveIcon from '@material-ui/icons/Save';

export type SaveButtonProps = PrimaryButtonProps & {
}

export function SaveButton (props: SaveButtonProps) {
    return <PrimaryButton startIcon={<SaveIcon />} {...props}>Salvar</PrimaryButton>
}